import { modelCatalogSchema } from "@wakeloop/schemas";
import type { ModelCatalog } from "@wakeloop/schemas/types";
import embeddedModelCatalog from "../../../../release/vendor-models.json";

let cachedModelCatalog: ModelCatalog | null = null;

export function readEmbeddedModelCatalog(): ModelCatalog {
  if (cachedModelCatalog) {
    return cachedModelCatalog;
  }
  cachedModelCatalog = modelCatalogSchema.parse(embeddedModelCatalog);
  return cachedModelCatalog;
}
